// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root div.Qtbfl.e9odV{font-size:.95rem}:root div.Qtbfl.e9odV label{color:#999;font-size:1em;padding-top:0!important}:root div.Qtbfl.e9odV label:before{filter:grayscale(1);opacity:1;transition:opacity,filter .25s ease-in-out}:root div.Qtbfl.e9odV label:after,:root div.Qtbfl.e9odV.L4fo_ label:before{opacity:.5}:root div.Qtbfl.e9odV.L4fo_ label:after{opacity:1}:root div.Qtbfl.e9odV.fZi4W label:after{background-color:#1b1c1d}:root div.Qtbfl.e9odV.ysmYn label:after{background-color:#2185d0}:root div.Qtbfl.e9odV.s_SiP label:after{background-color:#a5673f}:root div.Qtbfl.e9odV.NfnaA label:after{background-color:#21ba45}:root div.Qtbfl.e9odV.uMa_C label:after{background-color:#767676}:root div.Qtbfl.e9odV._YLge label:after{background-color:#b5cc18}:root div.Qtbfl.e9odV.dQOGw label:after{background-color:#f2711c}:root div.Qtbfl.e9odV._pvY_ label:after{background-color:#e03997}:root div.Qtbfl.e9odV.CQC4O label:after{background-color:#a333c8}:root div.Qtbfl.e9odV.FHme_ label:after{background-color:#db2828}:root div.Qtbfl.e9odV.DR0PI label:after{background-color:#00b5ad}:root div.Qtbfl.e9odV.gKtx1 label:after{background-color:#6435c9}:root div.Qtbfl.e9odV.RuJcU label:after{background-color:#fbbd08}:root div.Qtbfl.e9odV.lKqbg label:after{background-color:#fdfeff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Qtbfl`,
	"toggle": `e9odV`,
	"checked": `L4fo_`,
	"black": `fZi4W`,
	"blue": `ysmYn`,
	"brown": `s_SiP`,
	"green": `NfnaA`,
	"grey": `uMa_C`,
	"olive": `_YLge`,
	"orange": `dQOGw`,
	"pink": `_pvY_`,
	"purple": `CQC4O`,
	"red": `FHme_`,
	"teal": `DR0PI`,
	"violet": `gKtx1`,
	"yellow": `RuJcU`,
	"white": `lKqbg`
};
module.exports = ___CSS_LOADER_EXPORT___;
